t = require('app/scripts/views/internal/teacup-with-helpers')('popover_filter_pos_results')

module.exports = ->
  t.ul '.pop-over-list.navigable.normal-weight.js-pos-results', ->
    lists = [
      ['js-select-pos-keyword', t.mustacheVar('keywordList')]
      ['js-select-pos-pos', t.mustacheVar('indexList')]
      ['js-select-pos-list', t.mustacheVar('listList')]
    ]

    lists.forEach ([className, list]) -> list.forEach (entry) ->
      t.li ->
        t.a { href: '#', name: entry.value, class: className }, ->
          t.format 'position-in-list',
            index: entry.indexString
            listName: entry.listName
